import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import readXlsxFile from 'read-excel-file'
import { HelpersService } from 'src/core/services/helpers.service';
import { LandingPageService } from 'src/app/landing/landing-page.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-dialog-upload',
    templateUrl: './dialog-upload.component.html',
    styleUrls: ['./dialog-upload.component.scss'],
})
export class DialogUploadComponent {

    public files: NgxFileDropEntry[] = [];
    public fileReady: boolean = false;
    private fileToUpload: any;
    public isFileSelected: boolean = false;
    public uploadError: string = null;

    constructor(
        private helpersService: HelpersService,
        private landingPageService: LandingPageService,
        public dialogRef: MatDialogRef<DialogUploadComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    public dropped(files: NgxFileDropEntry[]) {
        this.fileReady = false;
        this.uploadError = null;
        this.isFileSelected = true;
        this.files = files;

        for (const droppedFile of files) {
            // Is it a file?
            if (droppedFile.fileEntry.isFile && this.isFileAllowed(droppedFile.fileEntry.name)) {
                const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

                fileEntry.file((file: File) => {
                    const myFileName = file.name;

                    // Convert to base64
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        readXlsxFile(file).then((rows) => {
                            let totalRows = 0;

                            for (const row of rows) {
                                if (!this.isNull(row)) {
                                    totalRows++;
                                }
                            }
                            
                            const effectiveRows = totalRows - 1;
;
                            if (totalRows < this.helpersService.config.data.api.massiveImport.max_file_rows) {
                                if (totalRows <= 1) {
                                    this.isFileSelected = false;
                                    files.pop();
                                    this.uploadError =  this.data.research_method && this.data.bea_max_points ? `File must have at least ${this.data.bea_max_points + 1} rows (excluding header)` : `File must have at least 1 row`;
                                    this.helpersService.handleError(null, this.uploadError);
                                }
                                //nel caso di import_multisite vado a controllare se ho più del numero di row che ho nei maxpoints e < 50
                                  else if (this.data.research_method && (effectiveRows <= this.data.bea_max_points || effectiveRows > 50)) {                           
                                this.isFileSelected = false;
                                files.pop();
                                this.uploadError = `File must have at least ${this.data.bea_max_points + 1} and no more than 50 rows (excluding header)`;
                                this.helpersService.handleError(null, this.uploadError);
                                } else {
                                    const base64String = reader.result.toString();
                                    const b64 = base64String.replace(/^data:.+;base64,/, '');
                                    this.fileReady = true;
                                    this.fileToUpload = {
                                        attachment_name: myFileName,
                                        attachment: b64,
                                        attachment_rows: totalRows,
                                        callback_url: `${environment.redirectSSOUrl}${environment.controls.unique_environment ? this.helpersService.config.data.route : ''}?activity=massive-detail`
                                    };
                                }
                            } else {
                                this.isFileSelected = false;
                                files.pop();
                                this.uploadError = `File must have less than ${this.helpersService.config.data.api.massiveImport.max_file_rows} rows`;
                                this.helpersService.handleError(null, this.uploadError);
                            }
                        });
                    };
                });
            } else {
                this.isFileSelected = false;
                files.pop();
                this.uploadError = 'File must be .XLSX or .XLS';
                this.helpersService.handleError(null, this.uploadError);
            }
        }
    }


    public saveFile() {
        this.landingPageService.fileToUpload = this.fileToUpload;
        this.dialogRef.close();
        this.isFileSelected = false;
    }

    private isFileAllowed(fileName: string) {
        let isFileAllowed = false;
        const allowedFiles = ['.xls', '.xlsx'];
        const regex = /(?:\.([^.]+))?$/;
        const extension = regex.exec(fileName);
        if (undefined !== extension && null !== extension) {
            for (const ext of allowedFiles) {
                if (ext === extension[0]) {
                    isFileAllowed = true;
                }
            }
        }
        return isFileAllowed;
    }

    private isNull(array) {
        for (let i = 0; i < array.length; i++) {
            if (array[i] !== null)
                return false;
            return true;
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
